<template>
<div style="background-color: #141414;">
  <b-container>
    <b-row align-v="center">
          <b-col cols="12" sm="12" md="12" lg="12">
            <p class="sign">Instagram</p>
            <p class="separator">&mdash; &#x2022; &mdash;</p>
          </b-col>
      </b-row>
  </b-container>
  <b-container fluid class="bg">
    <b-row class="justify-content-md-center textCentred">
        <div v-for="item in items" :key="item.id" class="noPadding">
          <img v-img:my-group :src="item.image" :alt="item.alt" class="resp">
        </div>
    </b-row>
  </b-container>
  <b-container class="bv-example-row bv-example-row-flex-cols">
    <b-row class="justify-content-md-center textCentred">
        <b-col cols="12" sm="12" md="2" lg="2" align-v="center">
        <img src="../assets/img/logoFooter.png">
        </b-col>
    </b-row>
    <b-row align-v="center">
        <b-col cols="12" sm="12" md="12" lg="12">
          <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique</p>
        </b-col>
    </b-row>
    <b-row class="justify-content-md-center">
        <b-col cols="2" sm="2" md="1" lg="1">
          <a href="https://www.facebook.com/" title="facebook"><img src="../assets/img/fbBlack.png"></a>
        </b-col>
        <b-col cols="2" sm="2" md="1" lg="1">
          <a href="https://twitter.com/" title="tweeter"><img src="../assets/img/tweeterBlack.png"></a>
        </b-col>
        <b-col cols="2" sm="2" md="1" lg="1">
          <a href="https://plus.google.com/discover" title="google plus"><img src="../assets/img/googleBlack.png"></a>
        </b-col>
        <b-col cols="2" sm="2" md="1" lg="1">
          <a href="http://hexagon.com/news/social-media" title="hexagon"><img src="../assets/img/hexagonBlack.png"></a>
        </b-col>
        <b-col cols="2" sm="2" md="1" lg="1">
          <a href="https://pl.pinterest.com/" title="pinterest"><img src="../assets/img/picsaBlack.png"></a>
        </b-col>
        <b-col cols="2" sm="2" md="1" lg="1">
          <a href="https://github.com/features" title="snapchat"><img src="../assets/img/gitBlack.png"></a>
        </b-col>
    </b-row>
    <b-row class="justify-content-md-center">
        <b-col cols="12" sm="12" md="6" lg="12">
          <hr>
        </b-col>
    </b-row>
  </b-container>
</div>
</template>
<script>
export default {
  data () {
    return {
      items: [
        {image: require('../assets/img/footerPhoto1.png'), alt: 'alt1'},
        {image: require('../assets/img/footerPhoto2.png'), alt: 'alt2'},
        {image: require('../assets/img/footerPhoto3.png'), alt: 'alt3'},
        {image: require('../assets/img/footerPhoto4.png'), alt: 'alt4'},
        {image: require('../assets/img/footerPhoto5.jpg'), alt: 'alt5'}
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
  .noPadding {
    padding-right: 0px!important;
    padding-left: 0px!important;
    width: 20%!important;
  }
  .sign {
    font-family: 'Playfair Display', serif;
    font-size: 30px;
    font-style: italic;
    text-align: center;
    margin-top: 15px;
    color: #ffffff;
  }
  .separator {
    text-align: center;
    color: #e8e8e8;
  }
  .bg {
    background-color: #141414;
  }

  @media only screen and (max-width: 1440px) {
   .noPadding {
      padding-right: 0px!important;
      padding-left: 0px!important;
      width: 33%!important;
    }
    .resp {
      width: 100%;
    }
  }
  @media only screen and (max-width: 1024px) {
     .noPadding {
      padding-right: 0px!important;
      padding-left: 0px!important;
      width: 50%!important;
    }
    .resp {
      width: 100%;
    }
  }
  @media only screen and (max-width: 767px) {
    .noPadding {
      padding-right: 0px!important;
      padding-left: 0px!important;
      width: 100%!important;
    }
    .resp {
      width: 100%;
    }
  }
  @media only screen and (max-width: 425px) {
    .noPadding {
      padding-right: 0px!important;
      padding-left: 0px!important;
      width: 100%!important;
    }
    .resp {
      width: 100%;
    }
  }
  @media only screen and (max-width: 375px) {
    .noPadding {
      padding-right: 0px!important;
      padding-left: 0px!important;
      width: 100%!important;
    }
    .resp {
      width: 100%;
    }
  }
  @media only screen and (max-width: 320px) {
    .noPadding {
      padding-right: 0px!important;
      padding-left: 0px!important;
      width: 100%!important;
    }
    .resp {
      width: 100%;
    }
  }



  .textCentred {
    text-align: center!important;
  }
  p {
    color: #ffffff;
    text-align: center;
  }
  hr {
    max-height: 3px;
    background-color: #ffffff;
  }
</style>



// WEBPACK FOOTER //
// src/components/Myfooter.vue?32710915